<template>
  <transition name="transition-fade">
    <div
      v-show="visible"
      :class="classList"
    >
      <div
        v-if="overlay"
        data-background
        :class="classListBackground"
      />
      <div class="absolute top-50 left-50 -translate-center z-20 flex flex-col items-center justify-center">
        <svg
          data-loader
          viewBox="25 25 50 50"
          :class="classListSpinner"
        >
          <circle
            data-path
            cx="50"
            cy="50"
            r="20"
            fill="none"
          />
        </svg>
        <div
          v-if="label"
          data-label
          :class="classListLabel"
        >
          {{ label }}
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * Loader.vue
 */
export default {
  props: {
    label: {
      type: String,
      default: null,
    },

    visible: {
      type: Boolean,
      default: false,
    },

    overlay: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {}
  },

  computed: {
    classList () {
      return [
        this.overlay ? 'z-40' : '',
      ]
    },

    classListBackground () {
      return [
        'absolute inset-0 bg-white opacity-75 z-10',
      ]
    },

    classListSpinner () {
      return [
        'w-6 h-6 stroke-current',
      ]
    },

    classListLabel () {
      return [
        'text-sm text-center',
      ]
    },
  },
}
</script>
